import { isMobile } from './isMobile';

export function mousePositionToIconColumnRow(element, mouseEvent) {
  const finalYPositions = isMobile() ? [0, 74, 148, 222] : [0, 146, 292, 438];
  const finalXPositions = isMobile() ? [0, 104, 208, 312, 416] : [100, 300, 500, 700, 900];

  const globalPoint = mouseEvent.data.global;
  const { tx, ty } = element.worldTransform;
  const containerX = globalPoint.x - tx;
  const containerY = globalPoint.y - ty;
  const iconHalfWidth = (isMobile() ? 98 : 194) / 2;
  const iconHalfHeight = (isMobile() ? 76 : 146) / 2;
  const column = finalXPositions.findIndex(
    (columnCenter) =>
      containerX >= columnCenter - iconHalfWidth && containerX <= columnCenter + iconHalfWidth
  );
  const row = finalYPositions.findIndex(
    (rowCenter) =>
      containerY >= rowCenter - iconHalfHeight && containerY <= rowCenter + iconHalfHeight
  );
  if (column > -1 && row > -1) {
    return { column, row };
  }
  return null;
}
